import React, { useEffect } from 'react';
import { getContent } from '@plone/volto/actions/content/content';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  buildVideoUrlFromFile,
  getSelectedExternalUrlFromItem,
  getSelectedUrlItem,
  getSelectedVideoPath,
  getVideoSubrequestId,
} from './utils';

const View = (props) => {
  const { data, className, block } = props;
  const dispatch = useDispatch();

  const selectedVideoItem = getSelectedUrlItem(data.url);
  const selectedUrl = typeof data.url === 'string' ? data.url.trim() : '';
  const selectedExternalUrlFromItem =
    getSelectedExternalUrlFromItem(selectedVideoItem);
  const selectedVideoPath = getSelectedVideoPath(selectedVideoItem);
  const selectedVideoSubrequest = getVideoSubrequestId(
    block,
    selectedVideoPath,
    'view',
  );
  const selectedVideoData = useSelector(
    (state) => state.content.subrequests?.[selectedVideoSubrequest]?.data,
  );

  useEffect(() => {
    if (!selectedVideoPath) return;
    dispatch(getContent(selectedVideoPath, null, selectedVideoSubrequest));
  }, [dispatch, selectedVideoPath, selectedVideoSubrequest]);

  const selectedVideoUrl = selectedVideoData?.url || '';
  const selectedVideoFileUrl = buildVideoUrlFromFile(selectedVideoData?.file);
  const resolvedUrl =
    selectedUrl ||
    selectedExternalUrlFromItem ||
    selectedVideoUrl ||
    selectedVideoFileUrl;

  if (!resolvedUrl) return null;

  return (
    <div
      className={cx(
        'block video align',
        {
          center: !Boolean(data.align),
        },
        data.align,
        className,
      )}
    >
      <Body data={{ ...data, url: resolvedUrl }} />
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
  block: PropTypes.string,
};

export default withBlockExtensions(View);
